import { render, staticRenderFns } from "./zbhxr.vue?vue&type=template&id=01065c58"
import script from "./zbhxr.vue?vue&type=script&lang=js"
export * from "./zbhxr.vue?vue&type=script&lang=js"
import style0 from "./zbhxr.vue?vue&type=style&index=0&id=01065c58&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports